import React from 'react';
import { Grid, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import imgPlaceholder from '../../../assets/images/imgPlaceholder.png';

const MealBasketItem = ({ meal, mealRemovedFromMealBasket }) => {
  return (
    <Grid
      item
      xs={12}
      key={meal.id}
      style={{ height: '82px', padding: '10px 0' }}>
      <Grid container>
        <Grid
          item
          className="mealBasketWidgetImage"
          xs={3}
          style={{
            backgroundImage: `url("${
              meal.recipes[0].imageUrl || imgPlaceholder
            }")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}>
          &nbsp;
        </Grid>
        <Grid
          item
          xs={7}
          style={{
            fontSize: '14px',
            padding: '5px',
            lineClamp: 3,
            WebkitLineClamp: 3,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
          }}>
          {meal.recipes[0].title}
        </Grid>
        <Grid item xs={2}>
          <IconButton
            aria-label="delete"
            size="small"
            onClick={(ev) => {
              mealRemovedFromMealBasket(meal.id);
              ev.stopPropagation();
            }}>
            <DeleteIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

MealBasketItem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  meal: PropTypes.object.isRequired,
  mealRemovedFromMealBasket: PropTypes.func.isRequired,
};

export default MealBasketItem;
